import React from 'react';
import { DoodleSquiggle } from '../brand/Doodles';
type EmptyStateProps = {
  title: string;
  copy: string;
  /** Small uppercase label above the title. */
  label?: string;
  children?: React.ReactNode;
  tone?: 'tan' | 'blue' | 'white';
};
const tones = {
  tan: 'bg-brand-tan',
  blue: 'bg-brand-blue',
  white: 'bg-white'
} as const;

/**
 * Reusable empty state for sections whose content has not been confirmed yet.
 * Keeps the page useful instead of inventing filler content.
 */
export function EmptyState({
  title,
  copy,
  label,
  children,
  tone = 'tan'
}: EmptyStateProps) {
  return <div className={`relative overflow-hidden rounded-[24px] border-2 border-dashed border-brand-navy p-7 sm:p-9 ${tones[tone]}`} data-id="element-445" data-mp="14p96y8lefd3g">
      <DoodleSquiggle className="pointer-events-none absolute -right-4 top-4 h-8 w-32 opacity-60" color="var(--bcm-dark-blue)" data-id="element-446" data-mp="19haittenn1sy" />
      {label ? <p className="font-meta text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-navy" data-id="element-447" data-mp="gyn0glr1m0vk">
          {label}
        </p> : null}
      <h3 className="mt-2 max-w-xl font-serif text-2xl font-semibold leading-snug text-brand-navy sm:text-[1.75rem]" data-id="element-448" data-mp="17r5r2geg0r24">
        {title}
      </h3>
      <p className="mt-3 max-w-xl font-sans text-[16px] leading-relaxed text-ink" data-id="element-449" data-mp="xyqczu69ommi">{copy}</p>
      {children ? <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-450" data-mp="t0yhyrabske3">{children}</div> : null}
    </div>;
}